<template>
  <nav class="navbar navbar-expand-lg">
    <div class="container-fluid">
      <a class="navbar-brand" href="#"></a>
     
      <div class="collapse navbar-collapse justify-content-end">
        <ul class="nav navbar-nav mr-auto">
          <li class="nav-item">

          </li>

          <li class="nav-item">
           
          </li>
        </ul>
        <ul class="navbar-nav ml-auto">
          <li class="nav-item">
            <a href="#" @click="logout()" class="nav-link">
              Log out
            </a>
          </li>
          <!-- <li class="nav-item">
                <a href="javascript:void(0);" @click="updateLanguage('en')" style="margin:7px">
                    <img alt="English" v-bind:src="require('../assets/images/uk.png')" />
                </a>
                <a href="javascript:void(0);" @click="updateLanguage('da')" >
                    <img alt="Denish" v-bind:src="require('../assets/images/denmark.png')" />
                </a>
          </li> -->
        </ul>
      </div>
    </div>
  </nav>
</template>
<script>
import Vue from 'vue'

  export default {
    computed: {
      routeName () {
        const {name} = this.$route
        return this.capitalizeFirstLetter(name)
      }
    },
    data () {
      return {
        activeNotifications: false
      }
    },
    methods: {
    async logout()
        {
          let loader = this.$loading.show()
        try
        {
          await this.$store.dispatch('auth/logout')
          this.$router.replace({
              name: `login`
          })
          loader.hide()   
        }
        catch(e)
        {
          localStorage.removeItem('token')
          loader.hide()  
          this.$router.replace({
              name: `login`
          })
                  
        }
          
        },
      capitalizeFirstLetter (string) {
        return string.charAt(0).toUpperCase() + string.slice(1)
      },
      toggleNotificationDropDown () {
        this.activeNotifications = !this.activeNotifications
      },
      closeDropDown () {
        this.activeNotifications = false
      },
      toggleSidebar () {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
      },
      hideSidebar () {
        this.$sidebar.displaySidebar(false)
      },
      async updateLanguage(lang)
      {
        let loader = this.$loading.show()

        try
        {
          localStorage.removeItem('lang')
          await Vue.prototype.$http.get('/api/auth/lang/'+lang)
          localStorage.setItem('lang', lang)
          this.$i18n.locale =  localStorage.getItem('lang')

          loader.hide()
        }
        catch(e)
        {
          loader.hide();
        }
      }
    }
  }

</script>
<style>

</style>
